import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";

import ModalConfirmButton from '../components/modal_close_button.tsx';

export default function ModalDach() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
    
  return (<Panel >
            <h1 id="modal-title">Wie ist das Dach gedämmt?</h1>
            <PropertyInput type="dach"/>
            <PropertyInput type="dach_datum"/>
            
           <ModalConfirmButton  onClick={()=>{
                close_menu();
                init_property_if_undefined("dach");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}

